import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography
} from '@material-ui/core';
import {
  AlertCircle as AlertCircleIcon,
  BarChart as BarChartIcon,
  Lock as LockIcon,
  Settings as SettingsIcon,
  ShoppingBag as ShoppingBagIcon,
  User as UserIcon,
  UserPlus as UserPlusIcon,
  Users as UsersIcon,
  Pocket as PocketIcon,
  Grid as GridIcon
} from 'react-feather';
import NavItem from '../NavItem';

import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import GppMaybeIcon from '@material-ui/icons/GppMaybe';

//Redux
import { useDispatch, useSelector } from "react-redux";

const items = [
  {
    href: '/app/dashboard',
    icon: GridIcon,
    title: 'Dashboard'
  },
  {
    href: '/app/financing',
    icon:  BarChartIcon,
    title: 'Financing'
  },
  {
    href: '/app/transactions',
    icon: PocketIcon,
    title: 'Transactions'
  },
  // {
  //   href: '/app/dashboard',
  //   icon: GridIcon,
  //   title: 'Dashboard'
  // },
  // {
  //   href: '/app/financing',
  //   icon: PocketIcon,
  //   title: 'Financing'
  // },
  // {
  //   href: '/app/products',
  //   icon: ShoppingBagIcon,
  //   title: 'Products'
  // },
  // {
  //   href: '/app/customers',
  //   icon: UsersIcon,
  //   title: 'Customers'
  // },
  // {
  //   href: '/app/questionnaire',
  //   icon: GridIcon,
  //   title: 'Questionnaires'
  // },
    {
    href: '/app/account',
    icon: UserIcon,
    title: 'Account'
  },
  // {
  //   href: '/app/settings',
  //   icon: SettingsIcon,
  //   title: 'Settings'
  // },

];

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
  const location = useLocation();
  const [values, setValues] = useState({});
  const [unVer, setVer] = useState(false);

  const { user, isLoggedIn } = useSelector((state) => state.auth);
 
 
 
 
 
 
 
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);


  useEffect(() => {
    if(user && user.personalDetails){
      setValues(user.personalDetails); 
    }

    if(user && user.isVerified){
      setVer(user.isVerified)
  }



  }, [user])
  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          p: 2
        }}
      >
        {/* <Avatar
          component={RouterLink}
          src="/static/Tlogo1.png"
          size={100} backgroundcolor="rgba(0,0,0,0)" style={{border: 0}}
          sx={{
            cursor: 'pointer',
            width: 64,
            height: 64
          }}
          to="/app/account"
        /> */}
           <img
            src="/static/Tlogo1.png"
            height="35px"
          />
        <Box
        //  component={RouterLink}
        //  to="/app/verify"
        className="m-1 center-element clickable nLink">
         {user && user.isVerified ?  <VerifiedUserIcon fontSize="small" className="text-success"/> : <GppMaybeIcon fontSize="small" className="text-danger"/>}&nbsp;
        <Typography
          color="textPrimary"
          variant="caption"
        
        >
      -&nbsp; { user && user.isVerified ? 'VERIFIED' :'NOT VERIFIED'}
        </Typography>
        </Box>
      </Box>
      <Divider />
      <Box sx={{ p: 2 }}>
        <List>
          {items.map((item) => (
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
            />
          ))}
        </List>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          PaperProps={{
            sx: {
              width: 256
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <Drawer
          anchor="left"
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: 256,
              top: 64,
              height: 'calc(100% - 64px)'
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

DashboardSidebar.defaultProps = {
  onMobileClose: () => { },
  openMobile: false
};

export default DashboardSidebar;
